import { PagePaths } from '@revelio/core';
import {
  healthCheckHash,
  healthCheckIdForRootField,
  healthChecksForEnvironment,
  type SharedRequest,
} from '@revelio/data-access';

import { environment } from '../environments/environment';

// The checks this environment's board shows (board.utils' BOARD_CHECKS): a
// link to one it leaves out — a deprecated op's, off prod — opens nothing.
const BOARD_CHECKS = healthChecksForEnvironment(environment.production);

/**
 * A link that opens the health-check playground on the check for `rootField`,
 * loaded with the request given — the Data Inspector's jump from "this is what
 * the page asked for" to "run it yourself and change it". On a `page` the
 * health check covers, it opens that page's check.
 *
 * `null` when no check on this environment's board probes the field, so a
 * caller can disable the control rather than offer a dead end.
 */
export const healthCheckPlaygroundLink = (
  rootField: string,
  request: SharedRequest,
  page?: string
): string | null => {
  const checkId = healthCheckIdForRootField(rootField, {
    page,
    checks: BOARD_CHECKS,
  });
  if (checkId === null) return null;
  return `/${PagePaths.HEALTH_CHECK}${healthCheckHash(checkId, request)}`;
};
